import React, { useContext } from 'react';
import tw from 'twin.macro';
import { Icon } from '../icon';
import { DumpertSingleDLogoIcon } from 'icons/';
import { PreferenceContext } from '../context';
import { Title } from '../text';

const PlaceholderItem = ({ landscape }) => (
  <div tw='animate-pulse'>
    <article css={[tw`rounded-lg opacity-50`, !landscape && tw`flex items-center`]}>
      <div
        css={[
          tw`rounded-lg bg-icons relative`,
          !landscape && tw`w-28 h-28 flex-shrink-0`,
          landscape && tw`aspect-w-16 aspect-h-9`,
        ]}
      >
        {landscape && <div tw='h-full w-full block'></div>}
      </div>
      <div tw='flex items-center flex-grow mt-1'>
        <div css={[tw`flex-grow px-4`, landscape && tw`pt-4 px-1`]}>
          <div tw='bg-icons w-full rounded-sm h-4 mb-3'></div>
          <div tw='bg-icons w-full rounded-sm h-4 mb-3'></div>
          <div tw='bg-icons w-full rounded-sm h-2'></div>
        </div>
      </div>
    </article>
  </div>
);

const PlaceholderSliderItem = ({ landscape }) => (
  <div tw='animate-pulse'>
    <article css={[tw`opacity-50`]}>
      <div tw='bg-icons relative aspect-w-16 aspect-h-9 from-dark to-transparent bg-gradient-to-t'></div>
    </article>
  </div>
);

const ItemsLoading = ({
  maxNumItems = 24,
  noLandscape = false,
  isSidebar = false,
  hideAds = false,
}) => {
  const placeHolders = [];
  const {
    preference: { landscape },
  } = useContext(PreferenceContext);
  for (let i = 0; i < maxNumItems; i++) {
    placeHolders.push(<PlaceholderItem key={i} landscape={landscape && !noLandscape} />);
  }
  return (
    <>
      {placeHolders}
      {hideAds && !isSidebar && <hr tw='my-8 border-icons opacity-30' />}
      {!hideAds && (
        <div tw='pt-2 pb-4 mx-auto w-[300px] sm:w-full sm:col-span-2 xl:col-span-3'>
          <div tw='bg-ads min-h-[250px] rounded-lg bg-opacity-20'></div>
        </div>
      )}
    </>
  );
};

const LoadingDot = ({ ...props }) => (
  <span tw='block rounded-full w-4 h-4 bg-brand animate-bounce' {...props}></span>
);

export const LoadingDots = () => (
  <>
    <div tw='flex w-[fit-content] pt-10 gap-2 mx-auto'>
      <LoadingDot />
      <LoadingDot style={{ animationDelay: '.2s' }} />
      <LoadingDot style={{ animationDelay: '.4s' }} />
    </div>
  </>
);

export const Loading = ({
  itemPlaceholder = false,
  sliderItemPlaceholder = false,
  maxNumItems,
  noLandscape,
  isSidebar,
  whatIsLoading = '',
  upload,
  hideAds,
  ...restProps
}) => {
  return (
    <>
      {itemPlaceholder && (
        <ItemsLoading
          maxNumItems={maxNumItems}
          noLandscape={noLandscape}
          isSidebar={isSidebar}
          hideAds={hideAds}
        />
      )}
      {sliderItemPlaceholder && <PlaceholderSliderItem />}
      {!itemPlaceholder && !sliderItemPlaceholder && (
        <div tw='flex flex-col items-center my-8 border-icons' {...restProps}>
          <Icon Type={DumpertSingleDLogoIcon} tw='mx-auto animate-bounce' />
          <Title Type='h4' text={`${whatIsLoading} aan het ${upload ? 'uploaden' : 'laden'}...`} />
        </div>
      )}
    </>
  );
};
